var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_19607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6683 6.30029C16.2997 5.91029 15.7044 5.91029 15.3358 6.30029L10.006 11.9403L11.3384 13.3503L16.6683 7.70029C17.0274 7.32029 17.0274 6.68029 16.6683 6.30029ZM20.6752 6.29029L11.3384 16.1703L8.04978 12.7003C7.68122 12.3103 7.08586 12.3103 6.71731 12.7003C6.34875 13.0903 6.34875 13.7203 6.71731 14.1103L10.6675 18.2903C11.036 18.6803 11.6314 18.6803 11.9999 18.2903L22.0076 7.71029C22.3762 7.32029 22.3762 6.69029 22.0076 6.30029H21.9982C21.6391 5.90029 21.0437 5.90029 20.6752 6.29029ZM1.37798 14.1203L5.32814 18.3003C5.69669 18.6903 6.29205 18.6903 6.6606 18.3003L7.32211 17.6003L2.71045 12.7003C2.34189 12.3103 1.74653 12.3103 1.37798 12.7003C1.00942 13.0903 1.00942 13.7303 1.37798 14.1203Z",
    fill: "#02E023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2152_19607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6803,
    height: 24,
    fill: "white",
    transform: "translate(0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaded);
export default __webpack_public_path__ + "static/media/readed.1622ea3b2984882077f0f92dcfd27a46.svg";
export { ForwardRef as ReactComponent };